import { useQuery } from "react-query"
import { getInvoiceReportData } from "./invoiceReportApi"

export const useGetInvoiceReportDataQuery = (startDate?: string, endDate?: string) => {
  return useQuery(['invoiceReport', startDate, endDate], {
    queryFn: () => getInvoiceReportData(startDate, endDate),
    refetchOnWindowFocus: false
  })
}